import
{
  Container,
  StyledCard,
  RecommendedContainer,
  RecommendedText,
  StyledCardContent,
  StyledCardActions,
  IconAvatarContainer,
  FeatureLinesContainer,
} from './SubscriptionCard.styles';
import IconAvatar from '../../Avatars/IconAvatar/IconAvatar';
import CardTitle from '../../Typography/CardTitle/CardTitle';
import FeatureLine from '../../Typography/FeatureLine/FeatureLine';
import OutlinedButton from '../../Buttons/OutlinedButton/OutlinedButton';
import SolidButton from '../../Buttons/SolidButton/SolidButton';
import StatusPill from '../../Pills/StatusPill/StatusPill';
import { Box, Stack } from '@mui/material';
import SectionSpinner from '../../Loading/SectionSpinner/SectionSpinner';
import { useState } from 'react';


const SubscriptionCard = ({
  avatarBgColor,
  icon,
  title,
  features,
  isRecommended,
  isExpired,
  isSelected,
  isActive,
  isTrial,
  isEnabled,
  showDowngrade,
  showUpgrade,
  onClick,
  willRedirect
}) =>
{
  const [redirectLoading, setRedirectLoading] = useState(false);
  const getButtonText = () =>
  {
    if (isSelected !== undefined)
    {
      return isSelected ? "Selected" : "Select";
    }
    if (isRecommended)
    {
      return showUpgrade ? "Upgrade" : "Activate";
    }
    return showDowngrade ? "Downgrade" : showUpgrade ? "Upgrade" : "Activate";
  };

  const getSubButtonText = (text) =>
  {
    if (willRedirect)
    {
      if (redirectLoading && 0 === text.toLowerCase().indexOf(redirectLoading))
      {
        return <SectionSpinner smaller="true" />
      }
    }
    return text;
  };

  const handleSubClick = (onClick, freq, event) =>
  {
    setRedirectLoading(freq);
    onClick(freq)
  };

  return (
    <Container>
      {isRecommended && (
        <RecommendedContainer>
          <RecommendedText>Recommended</RecommendedText>
        </RecommendedContainer>
      )}
      <StyledCard recommended={isRecommended ? "true" : undefined}>
        <StyledCardContent>
          <IconAvatarContainer>
            <IconAvatar bgColor={avatarBgColor} icon={icon} />
          </IconAvatarContainer>
          <CardTitle text={title} isRecommended={isRecommended} />
          {features &&
            features.map((feature) => (
              <FeatureLinesContainer key={feature}>
                <FeatureLine text={feature} isRecommended={isRecommended} />
              </FeatureLinesContainer>
            ))}
        </StyledCardContent>
        <StyledCardActions>
          {
            isExpired &&
            <StatusPill
              text={`${title} Expired`}
            />
          }
          {
            isActive &&
            <StatusPill
              text={'Active'}
              isActive
            />
          }
          {
            isSelected && !isExpired && !isActive &&
            <SolidButton
              text={getButtonText()}
              onClick={onClick}
            />
          }
          {
            !isExpired && !isActive && !isSelected && !isTrial && isEnabled &&
            <Stack direction="row" justifyContent="center" spacing={1} sx={{ width: "100%" }}>
              <OutlinedButton
                text={getSubButtonText("Monthly")}
                onClick={(event) => { handleSubClick(onClick, "monthly", event) }}
                fullWidth
              />
              <OutlinedButton
                text={getSubButtonText("Annually")}
                onClick={(event) => { handleSubClick(onClick, "annual", event) }}
                fullWidth
              />
            </Stack>
          }
          {
            isTrial && !isExpired &&
            <Stack direction="row" justifyContent="center" spacing={1} sx={{ width: "100%" }}>
              <OutlinedButton
                text="Activate"
                onClick={() => { onClick("trial") }}
                fullWidth
              />
            </Stack>
          }
        </StyledCardActions>
      </StyledCard>
    </Container>
  );
};

export default SubscriptionCard;
